import React from 'react';
import {
  Box,
  Typography,
  Button,
  makeStyles,
  createStyles,
  Theme,
} from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
    },
    content: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      gap: '16px',
    },
    textWrapper: {
      flex: 1,
    },
    label: {
      fontSize: '14px',
      fontWeight: 600,
      color: '#0066CC',
      marginBottom: '4px',
    },
    text: {
      fontSize: '13px',
      color: theme.palette.text.primary,
      margin: 0,
      lineHeight: '20px',
    },
    optimized: {
      backgroundColor: theme.palette.background.paper,
      padding: '12px',
      borderRadius: '4px',
    },
    library: {
      backgroundColor: 'transparent',
      padding: '12px 0',
    },
    addButton: {
      backgroundColor: '#003F2D',
      color: '#FFFFFF',
      textTransform: 'none',
      fontWeight: 600,
      padding: '8px 16px',
      '&:hover': {
        backgroundColor: '#00291E',
      },
    },
  }),
);

export interface PromptSuggestionProps {
  label: string;
  text: string;
  onAddPrompt?: () => void;
  variant?: 'optimized' | 'library';
  showButton?: boolean;
  className?: string;
}

export const PromptSuggestion: React.FC<PromptSuggestionProps> = ({
  label,
  text,
  onAddPrompt,
  variant = 'optimized',
  showButton = true,
  className = '',
}) => {
  const classes = useStyles();

  return (
    <Box className={`${classes.container} ${classes[variant]} ${className}`}>
      <Box className={classes.content}>
        <Box className={classes.textWrapper}>
          <Typography className={classes.label}>{label}</Typography>
          <Typography className={classes.text}>{text}</Typography>
        </Box>
        
        {showButton && onAddPrompt && (
          <Button
            variant="contained"
            onClick={onAddPrompt}
            size="medium"
            className={classes.addButton}
          >
            Add Prompt
          </Button>
        )}
      </Box>
    </Box>
  );
};
